import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

export const ERROR_MSGS = {
  name: 'Please enter an account holder name.',
  type: 'Please select an account type.',
  accountNumber: 'Please enter a valid account number.',
  routingNumber: 'Please enter a valid routing number.',
};

export default function BankAccountInfoForm({ handleACHSubmit, goBack }) {
  const FIELD_SPACING = 'mb-3';
  const {
    formState: { errors, isValid },
    handleSubmit,
    register,
  } = useForm({ mode: 'onBlur' });

  return (
    <Form id="PaymentForm" className="my-3" onSubmit={handleSubmit(handleACHSubmit)}>
      <h2>Bank Account Info</h2>
      <Form.Group className={FIELD_SPACING}>
        <Form.Label htmlFor="name">
          Account Holder Name
        </Form.Label>
        <Form.Control
          id="name"
          type="text"
          {...register('name', {
            required: ERROR_MSGS.name,
          })}
          isInvalid={!!errors.name}
        />
        {errors.name && (
          <Form.Control.Feedback type="invalid">
            {errors.name.message}
          </Form.Control.Feedback>
        )}

        <Form.Label htmlFor="type">
          Account Type
        </Form.Label>
        <Form.Select
          {...register('accountType')}
        >
          <option value="individual">Individual</option>
          <option value="company">Company</option>
        </Form.Select>

        <Form.Group>
          <Form.Label htmlFor="accountNumber">
            Account Number
          </Form.Label>
          <Form.Control
            type="text"
            id="accountNumber"
            minLength={5}
            maxLength={17}
            {...register('accountNumber', {
              required: ERROR_MSGS.accountNumber,
              pattern: {
                value: /[0-9]{5,17}/,
                message: 'Your account number must be between five and seventeen digits long.',
              },
            })}
            isInvalid={!!errors.accountNumber}
          />
          {errors.accountNumber && (
          <Form.Control.Feedback type="invalid">
            {errors.accountNumber.message}
          </Form.Control.Feedback>
          )}
          <Form.Text className="muted">
            Your account number is five to seventeen digits long
            and can be found in the bottom-middle of checks.
          </Form.Text>
        </Form.Group>

        <Form.Group>
          <Form.Label htmlFor="routingNumber">
            Routing Number
          </Form.Label>
          <Form.Control
            type="text"
            id="routingNumber"
            minLength={9}
            maxLength={9}
            {...register('routingNumber', {
              required: ERROR_MSGS.routingNumber,
              pattern: {
                value: /[0-9]{9}/,
                message: 'Your routing number must be nine digits long.',
              },
            })}
            isInvalid={!!errors.routingNumber}
          />
          {errors.routingNumber && (
            <Form.Control.Feedback type="invalid">
              {errors.routingNumber.message}
            </Form.Control.Feedback>
          )}
          <Form.Text className="muted">
            Your routing number is nine digits long and
            can be found on the bottom-left corner of checks.
          </Form.Text>
        </Form.Group>
      </Form.Group>

      <div className="mt-3 d-flex justify-content-around">
        <Button
          onClick={goBack}
          variant="dark"
        >
          Go Back
        </Button>
        <Button
          variant="primary"
          type="submit"
          disabled={!isValid}
        >
          Submit
        </Button>
      </div>
    </Form>
  );
}

BankAccountInfoForm.propTypes = {
  handleACHSubmit: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
};
